import axios from "axios";
import { detect } from "detect-browser";

const browser = detect();
const url = process.env.RSL_BACKEND_URL;
const anonKey = process.env.NEXT_PUBLIC_ANON_KEY;

export const axiosInstance = axios.create();

// Helper: check JWT expiry (assuming tokens are JWTs)
function isExpired(token) {
  try {
    const { exp } = JSON.parse(atob(token.split(".")[1]));
    return Date.now() >= exp * 1000;
  } catch {
    return true; // treat as expired if invalid
  }
}

async function getAccessTokenWithRefresh(refreshToken) {
  const res = await axios.post(`${url}/passenger/getAccessToken`, { refreshToken }, {
    headers: {
      "Authorization": `Bearer ${anonKey}` || "-",   // send "-" or handle missing case
    },
  });
  return res.data; // { accessToken, refreshToken }
}

async function checkDomainFlow() {
  // or wherever you store it  
  const res = await axios.post(`${url}/passenger/checkDomain`, {}, {
    headers: {
      "Authorization": `Bearer ${anonKey}` || "-",   // send "-" or handle missing case
    },
  });
  sessionStorage.removeItem("isVerify");
  return res.data; // { accessToken, refreshToken }
}


// Axios request interceptor
axiosInstance.interceptors.request.use(async (config) => {
  const rslkey = sessionStorage.getItem("rslkey"); // user login key
  let accessToken = sessionStorage.getItem("accessToken");
  let refreshToken = sessionStorage.getItem("refreshToken");
  // ---- Flow ----
  if (rslkey) {
    // ✅ User is logged in
    if (!accessToken || isExpired(accessToken)) {
      if (refreshToken && !isExpired(refreshToken)) {
        try {
          const tokens = await getAccessTokenWithRefresh(refreshToken);
          sessionStorage.setItem("accessToken", tokens.accessToken);
          sessionStorage.setItem("refreshToken", tokens.refreshToken);
          accessToken = tokens.accessToken;
        } catch {
          // Refresh failed → logout
          sessionStorage.clear();
          const tokens = await checkDomainFlow();
          sessionStorage.setItem("accessToken", tokens.guestToken);
          sessionStorage.setItem("refreshToken", tokens.refreshToken);
          accessToken = tokens.guestToken;
        }
      } else {
        // Refresh token missing/expired → logout
        sessionStorage.clear();
        localStorage.clear();
        const tokens = await checkDomainFlow();
        sessionStorage.setItem("accessToken", tokens.guestToken);
        sessionStorage.setItem("refreshToken", tokens.refreshToken);
        accessToken = tokens.guestToken;
        window.location.reload();
      }
    }
  } else {
    // 🚪 Guest user flow
    if (!accessToken || !refreshToken) {
      const tokens = await checkDomainFlow();
      sessionStorage.setItem("accessToken", tokens.guestToken);
      sessionStorage.setItem("refreshToken", tokens.refreshToken);
      accessToken = tokens.guestToken;
    }
  }

  // Attach common query params
  const commonQueryParams = {
    dID: "TKQ1.221114.001",
    dt: "a",
    lat: localStorage.getItem("latitude") ?? "0",
    lng: localStorage.getItem("longitude") ?? "0",
    currencyCode:
      typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed",
    browserName: browser?.name ?? "-",
    deviceDetails: window.navigator.userAgent,
    platform: window.navigator.userAgentData
      ? window.navigator.userAgentData.platform
      : "-",
    version: window.navigator.vendor,
    connection:
      window.clientInformation?.connection?.effectiveType ?? "-",
  };

  config.params = {
    ...config.params,
    ...commonQueryParams,
  };

  // Attach Authorization header if available
  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return config;
});
